export enum AutomatedTestType {
    Smoke = 0,
    Regression = 1
}